import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader, showOverlay} from './LoaderSlice';

const loader = (props) => {
  useEffect(() => {
    if (props.isLoading) {
      props.showOverlay(props.overlay);
    }
  }, [props.isLoading, props.overlay]);

  return (
    <div>
      {props.isLoading ? (
        <div className='loader'>
          {props.isOverlay ? <div className='overlay'></div> : null}
          <div className='spinner-container'>
            <div className='spinner'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 34'>
                <g fill='none' fillRule='evenodd'>
                  <g fill='var(--theme-primary, #810ea9)' fillRule='nonzero'>
                    <path d='M29.4 12.4c-.08-.32-.2-.68-.32-1-.12-.36-.28-.64-.4-.92s-.24-.52-.4-.76c.12.2.2.44.32.68.08.28.24.6.32.92.08.32.2.68.32 1 .32 1.4.52 3 .32 4.8-.16 1.72-.72 3.6-1.68 5.36-.96 1.68-2.36 3.28-4.2 4.48-.44.28-.88.6-1.36.8-.2.08-.48.24-.72.32-.24.08-.52.2-.76.32-1.04.4-2.12.68-3.24.72l-.44.04-.44.04h-.84c-.56-.04-1.16-.04-1.68-.2-.56-.04-1.12-.24-1.64-.32-.56-.2-1.08-.36-1.56-.6s-.96-.48-1.48-.76c-.24-.12-.48-.28-.68-.44l-.32-.24c-.12-.04-.24-.16-.32-.24l-.32-.24-.16-.16-.08-.08-.04-.04-.04-.04-.6-.6c-.48-.4-.76-.84-1.08-1.24-.16-.16-.28-.44-.44-.68L5 22.64l-.36-.72c-.08-.2-.24-.48-.32-.72-.16-.48-.4-.96-.48-1.48-.08-.24-.16-.48-.2-.76l-.12-.72c-.12-.48-.12-.96-.16-1.48-.04-.48 0-1 .04-1.48.08-.48.12-.96.24-1.4.04-.24.12-.44.16-.68l.04-.32.12-.32c.6-1.72 1.52-3.2 2.6-4.4.32-.32.56-.6.84-.84.36-.36.56-.52.88-.72.56-.48 1.16-.8 1.72-1.12 1.12-.6 2.2-.92 3.08-1.12.88-.2 1.6-.28 2.08-.24.24-.04.44 0 .56 0h.2c1.08.04 2-.88 2-2 .04-1.08-.88-2-2-2h-.12s-.08.04-.24.04c-.16 0-.4 0-.72.04-.64.04-1.6.16-2.76.48-1.16.32-2.56.8-3.96 1.64-.72.4-1.44.92-2.16 1.52-.36.32-.76.64-1 .96l-.24.24c-.08.08-.2.16-.24.28-.2.16-.32.36-.52.56C2.68 7.44 1.6 9.4.96 11.6l-.12.4-.08.44c-.04.28-.12.56-.16.84-.12.6-.16 1.16-.2 1.8 0 .6-.04 1.2.04 1.8.08.6.08 1.2.24 1.84.04.28.12.6.16.92.08.32.2.6.28.92.16.64.44 1.2.68 1.76.12.28.28.56.44.84.16.32.32.56.48.84.2.28.36.56.56.8.2.24.36.52.6.76.44.52.88 1.08 1.32 1.4l.68.64.04.04.04.04.04.04h.08l.2.16.4.28c.16.08.24.2.4.28l.44.24c.32.16.56.36.84.48.56.28 1.16.6 1.76.8.6.28 1.24.4 1.84.6.6.12 1.24.28 1.88.32.64.08 1.24.08 1.88.08.32 0 .64-.04.96-.04l.48-.04.44-.04c1.24-.16 2.44-.52 3.56-.96.32-.12.56-.24.84-.36.28-.12.52-.28.8-.44.52-.28 1.04-.68 1.48-1 .2-.16.4-.36.64-.52l.32-.24.08-.08.04-.04c.04-.04 0 0 0 0v.04l.04-.04.16-.16.6-.6.32-.32.28-.32c.36-.44.72-.88 1-1.32.16-.24.28-.44.44-.68.12-.28.24-.48.36-.72.96-1.96 1.4-3.92 1.48-5.76.08-1.84-.2-3.52-.64-4.92z' />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {isLoading: state.loader.isLoading, isOverlay: state.loader.isOverlay};
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  showOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(loader);
